export enum PaymentMethod {
  PAY_ANYONE = "pay-anyone",
  SAVED_CARDS = "saved-cards",
  ADD_CARDS = "add-cards",
}
